import { CheckPermissionLayout } from 'layouts';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { PERMISSION } from 'utils';
import { ROUTE } from './constants';

export const accessCreateTicketFromExcelRoute: RouteObject[] = [
    {
        element: <CheckPermissionLayout permission={[PERMISSION.ACCESS_CREATE_TICKET_FROM_EXCEL]} />,
        children: [
            {
                path: ROUTE.CREATE_TICKET_FROM_EXCEL,
                children: [
                    {
                        index: true,
                        Component: lazy(() => import('pages/CreateTicketFormExcel'))
                    }
                ]
            }
        ]
    }
];
